<template>
  <div>
    <!-- モーダル設定 -->
    <SelectionOptionsModal
      v-if="isSelectionOptionsModalOpen"
      :isSelectionOptionsModalOpen="isSelectionOptionsModalOpen"
      :columnId="selectedColumnId"
      :columnName="selectedColumnName"
      @save="onSaveSelectionOptions"
      @save-option-order="saveOptionOrder"
      @close="closeSelectionModal"
    />
    <!-- カスタムカラムを選択する際のモーダル -->
    <ModalTypeForCustomColumn
      ref="modalTypeForCustomColumn"
      @selection-confirmed="handleCustomColumnSelection"
    />

    <!-- テーブル設定 -->
    <transition name="right">
      <div style="position: absolute; top: 0; right: 0; height: 100vh; width: 54%; min-width: 1025px; background: #FEFEFE; padding: 16px; z-index: 201; overflow: scroll;" v-if="isOpenTableSettingMenu">
        <h2 style="margin-bottom: 8px; font-weight: 600;"><span class="mdi mdi-table-settings" style="margin-right: 8px;"></span>テーブル設定 ※閉じた際に設定が自動反映されます。</h2>
          <div style="display: flex; align-items: center; margin-bottom: 8px;">
            <input
              class="input is-small"
              placeholder="カラム名"
              v-model="tempColumns"
              @input="updateTempColumns"
              style="margin-left: 10px; width: calc(100% - 160px);"
            />
            <button 
              class="button is-small" 
              style="width: 60px;" 
              @click="openModalTypeForCustomColumn"
            >
              <span class="mdi mdi-plus" style="margin-right: 8px;"></span>追加
            </button>
          </div>
        <table class="disp-scroll" v-if="tempCompanyColumnSetting.length > 0">
          <tr style="display: table;">
            <th style="width: 60px;">移動</th>
            <th style="width: 60px;">順番</th>
            <th style="width: 200px;">カラム名</th>
            <th style="width: 90px;">表示</th>
            <th style="width: 90px;">固定</th>
            <th style="width: 90px;">折り返し</th>
            <th style="width: 90px;">権限</th>
            <th style="width: 90px;">選択</th>
            <th style="width: 60px;">削除</th>
          </tr>
          <draggable id="story-list" :list="tempCompanyColumnSetting" @end="saveColumnOrder(tempCompanyColumnSetting)" :options="{animation: 300, group: { name: 'TEMP', pull: 'clone', put: false}, handle: '.drag-button'}">
            <tr style="display: table;" v-for="(t, i) in tempCompanyColumnSetting" :key="i + '-col'">
              <td style="width: 60px; vertical-align: middle; padding: 0; overflow: hidden;">
                <button class="drag-button trans-btn" @click="reflectSwitch()"><span class="mdi mdi-drag mdi-24px"></span></button>
              </td>
              <td style="width: 60px; vertical-align: middle;">{{t.order_type + 1}}</td>
              <td style="min-width: 180px; width: 25%; text-align: left; vertical-align: middle;">
                <input
                  class="input is-small"
                  style="background: transparent;"
                  v-model="t.name"
                  v-if="t.template_type == 0 && t.is_item_master == false"
                  @focus="tempColName = t.name;"
                  @blur="checkColName(t.name, i)"
                  />
                <div style="height: 35px; line-height: 35px; padding-left: 5px;" v-else>{{t.name}}</div>
              </td>
              <td style="width: 90px; text-align: center; vertical-align: middle;">
                <b-switch
                  size="is-small"
                  v-model="t.is_disabled"
                  :true-value="false"
                  :false-value="true"
                  @input="refresh()"
                >
                  {{t.is_disabled ? 'OFF' : 'ON'}}
                </b-switch>
              </td>
              <td style="width: 90px; text-align: center; vertical-align: middle;">
                <b-switch
                  size="is-small"
                  v-model="t.is_sticky"
                  :true-value="true"
                  :false-value="false"
                  @input="refresh()"
                  :disabled="disabledChecked(i)"
                >
                  {{t.is_sticky ? 'ON' : 'OFF'}}
                </b-switch>
              </td>
              <td style="width: 90px; text-align: center; vertical-align: middle;">
                <template v-if="t.template_type === 0 && !t.is_pulldown_flg && t.type_for_custom_column !== 3">
                  <b-switch
                    size="is-small"
                    v-model="t.is_multiline"
                    :true-value="true"
                    :false-value="false">
                    {{t.is_multiline ? 'ON' : 'OFF'}}
                  </b-switch>
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td style="width: 90px; text-align: center; vertical-align: middle;">
                <template v-if="t.template_type === 0">
                  <b-switch
                    size="is-small"
                    v-model="t.is_authcontrol"
                    :true-value="true"
                    :false-value="false">
                    {{t.is_authcontrol ? 'ON' : 'OFF'}}
                  </b-switch>
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td style="width: 90px; text-align: center; vertical-align: middle;">
                <template v-if="t.template_type === 0">
                  <template v-if="t.is_pulldown_flg">
                    <button class="button is-small" @click="openSelectionModal(t)">
                      <span class="mdi mdi-menu -right-8px"></span>詳細
                    </button>
                  </template>
                  <template v-else>
                    -
                  </template>
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td style="width: 60px; text-align: center; vertical-align: middle;">
                <template v-if="t.template_type === 0 && t.is_item_master == false">
                  <div style="display: flex;">
                    <button class="trans-btn" @click="deleteCompanyColumnSetting(t.pk)">
                      <span class="mdi mdi-close"></span>
                    </button>
                  </div>
                </template>
                <template v-else>
                  必須
                </template>
              </td>
            </tr>
          </draggable>
        </table>
      </div>
    </transition>
  </div>
</template>

<script>
import draggable         from 'vuedraggable'
import { mapState, mapActions } from 'vuex';
import SelectionOptionsModal from '@/components/Manage/SelectionOptionsModal'
import ModalTypeForCustomColumn from '@/components/Manage/ModalTypeForCustomColumn'

export default {
  components: {
    draggable,
    SelectionOptionsModal,
    ModalTypeForCustomColumn,
  },
  data () {
    return {
      tempColumns: '',
      tempColName: '',
    }
  },
  props: {
    tempCompanyColumnSetting: {
      type: Array,
      required: true
    },
    isOpenTableSettingMenu: {
      type: Boolean,
      required: true
    },
    isSelectionOptionsModalOpen: {
      type: Boolean,
      required: true
    },
  },
  methods: {
    reflectSwitch() {
      // b-switchの表示がおかしくなるので、更新(boolを2回反転)して反映
      for (let setting of this.tempCompanyColumnSetting) {
        setting.is_disabled = !setting.is_disabled
        setting.is_sticky = !setting.is_sticky
        setting.is_multiline = !setting.is_multiline
        setting.is_authcontrol = !setting.is_authcontrol
      }
      this.$nextTick(()=>{
        for (let setting of this.tempCompanyColumnSetting) {
          setting.is_disabled = !setting.is_disabled
          setting.is_sticky = !setting.is_sticky
          setting.is_multiline = !setting.is_multiline
          setting.is_authcontrol = !setting.is_authcontrol
        }
      })
    },
    refresh () {
      //再描画しないと表示がおかしくなるのでここで再描画
      this.$store.dispatch('directtalk/refleshSeekerColomn')
    },
    saveColumnOrder (temp) {
      this.$emit('save-column-order', temp)
    },
    // 一時的なカラムを更新
    updateTempColumns(event) {
      this.tempColumns = event.target.value.trim();
    },
    openModalTypeForCustomColumn() {
      if (!this.tempColumns || this.tempColumns.length <= 0) {
        alert('一文字以上入力してください')
        return
      }
      if (this.isDuplicated(this.tempColumns)) {
        this.openAlert()
        this.tempColumns = ''
        return
      }
      this.$refs.modalTypeForCustomColumn.openModal()
    },
    handleCustomColumnSelection(selection) {
      let data = { columns: this.tempColumns };
      switch(selection.type) {
        case '1':
          data.isPulldown = false;
          data.type_for_custom_column = 1;
          break;
        case '2':
          data.isPulldown = true;
          data.type_for_custom_column = 2;
          break;
        case '3':
          data.type_for_custom_column = 3;
          break;
      }
      this.$emit('create-company-column-setting', data);
      this.tempColumns = '';
    },
    deleteCompanyColumnSetting (pk) {
      if (window.confirm('カラムを削除すると、カラムに紐づいているデータも削除されますがよろしいでしょうか？')) {
        this.$emit('delete-company-column-setting', pk)
      }
    },
    disabledChecked (i) {
      if (this.tempCompanyColumnSetting[i + 1]) {
        if (this.tempCompanyColumnSetting[i + 1].is_sticky) {
          return true
        } else if (i === 0) {
          return false
        } else if (this.tempCompanyColumnSetting[i - 1].is_sticky === false) {
          return true
        } else {
          return false
        }
      } else if (this.tempCompanyColumnSetting[i - 1].is_sticky === false) {
        return true
      }
    },
    isDuplicated (newVal) {
      return this.tempCompanyColumnSetting.some(obj => obj.name === newVal)
    },
    openAlert () {
      this.$buefy.snackbar.open({
        message: 'カラム名が重複しています',
        type: 'is-warning',
        position: 'is-top',
        actionText: '閉じる',
        indefinite: true,
      })
    },
    checkColName (newVal, index) {
      let filteredCol = this.tempCompanyColumnSetting.filter(obj => obj.name === newVal)
      if (filteredCol.length <= 1) return  
      this.openAlert()
      this.tempCompanyColumnSetting[index].name = this.tempColName
    },
    // 選択式入力カラムのモーダルを開く
    openSelectionModal(t) {
      this.selectedColumnId = t.pk; // t.pkを保存
      this.selectedColumnName = t.name;
      this.$store.dispatch('auth/fetchCompanyPulldownColumns', { columnId: t.pk });
      this.$emit('open-selection-modal', { columnId: t.pk, columnName: t.name });
    },
    // 選択オプションを保存
    onSaveSelectionOptions(tempPulldownColumnOptions) {
      this.$emit('save-selection-options', tempPulldownColumnOptions);
    },
    // 選択オプションの順番変更を保存
    saveOptionOrder(tempPulldownColumnOptions) {
      this.$emit('save-option-order', tempPulldownColumnOptions);
    },
    // 選択モーダルを閉じる
    closeSelectionModal() {
      this.$emit('close-selection-modal');
      this.selectedColumnId = null;
    },
  },
  computed: {
    ...mapState('auth', ['user', 'companyColumnSetting']),
  },
}
</script>

<style scoped lang="scss">
table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  min-width: 1000px;
  border-collapse: collapse;
  margin: 0 auto;
  display: block;  // これを追加
  height: calc(100vh - 120px);  // max-heightをheightに変更
  overflow-y: auto;  // これを追加
}
table::-webkit-scrollbar {
  //width:  5px;
  //height: 5px;
  //visibility: hidden;
}
tr {
  width: 100%;
}
td,th {
  padding: 8px;
  margin: auto;
  font-size: smaller;
  border-style: solid;
  border-width: 1px;
  border-color: #AA0066;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
td {
  text-align: left;
  overflow: scroll;
  padding: 8px;
  .b-switch {
    display: inline-flex;
    justify-content: center;
    width: 100%;
  }
  
  button {
    min-width: fit-content;
  }  
}
td > div::-webkit-scrollbar {
  width:  5px;
  height: 5px;
  visibility: hidden;
}
// カラム名のセルのみ折り返しを許可する場合
td:nth-child(3), th:nth-child(3) {
  padding: 8px;
  text-align: left;
  word-break: break-word;
  white-space: normal;
}
// テーブル全体の横スクロールを有効にする
.disp-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  white-space: nowrap;
}
.disp-scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.disp-scroll::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}
th {
  color:#fff;
  background:#AA0066;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10000;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}
.trans-btn {
  width: 100%;
  height: 35px;
  background: transparent;
  border: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/TableSetting.vue